import { useCallback } from "react";
import { PublicPageHeader } from "../../../components/headers/header-public-page/header-public-page";
import { Navbar } from "../../../components/nav";
import { useThemeQueries } from "../../../theme";
import { useStyles } from "./assinatura-entrega-page-styles";
import { AssinaturaEntregaData } from "./components/assinatura-entrega-data";
import { useHistory } from "react-router";

const AssinaturaEntregaPage = () => {

    const classes = useStyles();
    const { isMobile } = useThemeQueries();
    const history = useHistory();

    const voltar = useCallback(() => {
        history.replace('/')
    }, [history])

    return (
        <>
            <PublicPageHeader topOpacity="0.8" />
            <div className={classes.divRoot}>
                <Navbar
                    buttonBack={true}
                    titulo={isMobile ? 'Coloque a Assinatura' : 'Assinatura'}
                    voltar={voltar}
                />
                <div className={classes.root}>
                    <AssinaturaEntregaData />
                </div>
            </div>
        </>
    )
}

export default AssinaturaEntregaPage;